"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var usePagination = function () {
    var _a = React.useState(1), page = _a[0], setPage = _a[1];
    var _b = React.useState(0), lastPage = _b[0], setLastPage = _b[1];
    var navigateToPage = function (pageToSet) {
        var value;
        if (pageToSet < 1) {
            value = 1;
        }
        else if (lastPage && pageToSet > lastPage) {
            value = lastPage;
        }
        else {
            value = pageToSet;
        }
        setPage(value);
    };
    var navigateBackwards = function () {
        var pagebackwards = page - 1;
        navigateToPage(pagebackwards);
    };
    var navigateForwards = function () {
        var pageForwards = page + 1;
        navigateToPage(pageForwards);
    };
    var gotoPage = function (event) {
        navigateToPage(Number(event.target.value));
    };
    return [
        page,
        setLastPage,
        lastPage,
        navigateToPage,
        navigateBackwards,
        navigateForwards,
        gotoPage
    ];
};
exports.default = usePagination;
